import React, {useRef, useState, useContext, useEffect} from 'react';
import { Button } from "react-bootstrap";
import "./profile.style.css";
import { useNavigate } from 'react-router-dom';
import { ModalElement } from "../../components/modal/modalElement";
import Form from 'react-bootstrap/Form';
import Load from '../../components/load/load';
import InputGroup from 'react-bootstrap/InputGroup';
import { ErrorModal } from '../../components/toast/errorModal';
import {Context} from '../../context/AuthContext';
import api from '../../services/api';
import jwt_decode from "jwt-decode";

export function Profile(){
    const formEditUserRef = useRef(null);
    const navigate = useNavigate();
    const [modalShow, setModalShow] = React.useState(false);
    const [modalEditAccount, setModalEditAccount] = React.useState(false);
    const [validated, setValidated] = useState(true);
    const [ name, setName ] = useState('');
    const [ nameTouched, setNameTouched ] = useState(false);
    const [ email, setEmail ] = useState('');
    const [ emailTouched, setEmailTouched ] = useState(false);
    const [ password, setPassword ] = useState('');
    const [ defaultEmail, setDefaultEmail ] = useState('');
    const [ passwordTouched, setPasswordTouched ] = useState(false);
    const { handleEditUser, isFetchingEditUser, createError } = useContext(Context);
    const loginToken = JSON.parse(localStorage.getItem('token'));
    const {uso_nome, uso_id} = jwt_decode(loginToken);



    const logout = () => {
        navigate('/');
        localStorage.removeItem('token');
    }

    const deleteAccount = async () => {
        try {
            await api.delete(`/users/${uso_id}`, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });
            setModalShow(false)
            logout();
        } catch(error) {
            console.error(error);
        }        
    }

    useEffect(() => {
        setValidated(!!name && !!email && !!password);
    }, [email, password, name]);

    const handleSubmit = (event) => {    
        if (!formEditUserRef.current.checkValidity()) {
            setValidated(true);
            return;
        }
        handleEditUser(name, email === defaultEmail ? '' : email, password);
        setModalEditAccount(false);
    };

    const openEditAccountModal = async () => {
        try {
            await api.get(`/users/${uso_id}`, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            })
            .then(res => {
                setName(res.data.uso_nome);
                setEmail(res.data.uso_email);
                setDefaultEmail(res.data.uso_email);
            })
            .catch(err => console.log(err))
            .finally(() => setModalEditAccount(true));            
        } catch(error) {
            console.error(error);
        } 
        
    }

    return (
        <>
            <h1>Olá, {uso_nome}!</h1>
            <div className="container container-reminder">
                <div className="second-container-profile">
                    <Button className="edit-btn" onClick={() => openEditAccountModal()}>EDITAR PERFIL</Button>
                    <Button className="logout-btn" onClick={() => logout()}>LOGOUT</Button>
                    <Button className="delete-btn" onClick={() => setModalShow(true)}>EXCLUIR CONTA</Button>
                </div>
            </div>
            <ModalElement
                size='m'
                show={modalShow}
                onHide={() => setModalShow(false)}        
            >
                <h2 className='delete-account-text'>Tem certeza que quer deletar a sua conta?</h2>
                <div className='delete-buttons'>
                    <Button className='delete-btn delete-btn-account' onClick={() => setModalShow(false)}>NÃO</Button>
                    <Button className='edit-btn edit-btn-account' onClick={() => deleteAccount()}>SIM</Button>
                </div>
            </ModalElement>

            <ModalElement
                size='m'
                show={modalEditAccount}
                onHide={() => setModalEditAccount(false)}        
            >
                <h2 className='criar-conta-text'>Editar perfil</h2>
                <Form ref={formEditUserRef} validated={validated} id="form-edit">
                    <Form.Group className="mb-3" controlId="formBasicName">
                        <Form.Label>Nome</Form.Label>
                        <InputGroup hasValidation>
                            <Form.Control defaultValue={name} onTouchStart={() => setNameTouched(true)} onChange={(e) => setName(e.target.value)} type="text" isInvalid={nameTouched && !name}/>
                            <Form.Control.Feedback type="invalid">
                                Nome inválido.
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <InputGroup hasValidation>
                            <Form.Control defaultValue={email} onTouchStart={() => setEmailTouched(true)} onChange={(e) => setEmail(e.target.value)} type="email" isInvalid={emailTouched && !email}/>
                            <Form.Control.Feedback type="invalid">
                                Email inválido.
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Senha</Form.Label>
                        <InputGroup hasValidation>
                            <Form.Control placeholder='Somente insira uma senha se deseja alterá-la!' onTouchStart={() => setPasswordTouched(true)} onChange={(e) => setPassword(e.target.value)} type="password" isInvalid={passwordTouched && !password}/>
                            <Form.Control.Feedback type="invalid">
                                Senha inválida.
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Button className='button' onClick={(e) => handleSubmit(e)} variant="primary" type="button">
                        {isFetchingEditUser? <Load /> : 'ATUALIZAR'}
                    </Button>
                    {createError.isError && <ErrorModal text={createError.message} show={true}/>}
                </Form>
            </ModalElement>
        </>
    )
}